/**
 * Return a string that converts the number to a letter
 * e.g. 0 = a; 8 = i; 26 = aa;
 * @param num
 */
export function numberToLetter(num: number) {
  let result = "";
  do {
    result = ((num % 26) + 10).toString(36) + result;
    num = Math.floor(num / 26) - 1;
  } while (num >= 0);
  return result;
}
